/* eslint-disable no-console */
/* eslint-disable no-param-reassign */

import Cookies from 'js-cookie';
import { UserAddresses } from '../auth/types';
import { ParameterAction, ParameterState, ParameterActionTypes } from './types';

const INITIAL_STATE: ParameterState = {
  control_version: `VersionApp: ${process.env.REACT_APP_VERSION} - ${process.env.REACT_APP_BUILD_DATE}`,
  versionApp: process.env.REACT_APP_VERSION
    ? process.env.REACT_APP_VERSION
    : '0',
  confRefrashApp: true,
  isShowLeft: false,
  isShowRight: false,
  openMenu: false,
  payOnDelivery: false,
  isCreatedMethod: true,
  parameter: {
    isCategory: false,
  },
  methodsType: {
    options: {
      cards: [],
      cashOnDelivery: [],
      others: [],
    },
    methodsLength: 0,
  },
  address: {} as UserAddresses,
  language: 'pt', // Define português como idioma padrão,
  multistoreSelected: JSON.parse(Cookies.get('@ConectoVarejo:multistoreSelected') || '{}')
};

export default function parameter(
  state = INITIAL_STATE,
  action: ParameterAction,
): ParameterState {
  switch (action.type) {
    case ParameterActionTypes.OPEN_MENU:
      return {
        ...state,
        isShowLeft:
          action.payload.data.side === 'left' ? !state.isShowLeft : false,
        isShowRight:
          action.payload.data.side === 'right' ? !state.isShowRight : false,
      };
    case ParameterActionTypes.OPEN_MENU_BASE:
      //konsole.log('OPEN_MENU_BASE');
      return {
        ...state,
        openMenu: !state.openMenu,
      };
    case ParameterActionTypes.OPEN_MODAL:
      return {
        ...state,
        openModal: action.payload.open ? true : false,
      };
    case ParameterActionTypes.VIEW_MODAL:
      return {
        ...state,
        viewModal: action.payload.content,
        viewModalProps: action.payload.props,
        ...(action.payload.open ? {
          openModal: action.payload.open
        } : {})
      };
    case ParameterActionTypes.IS_CATEGORY:
      return {
        ...state,
        parameter: {
          ...state.parameter,
          isCategory: action.payload.isCaregory,
        },
      };
    case ParameterActionTypes.FIND_METHODS_ALL:
      return {
        ...state,
        loading: true,
        methodsAll: [],
      };
    case ParameterActionTypes.FIND_METHODS_ALL_SUCCESS:
      return {
        ...state,
        loading: false,
        methodsAll: action.payload.methods,
      };
    case ParameterActionTypes.FIND_METHODS_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        methodsType: action.payload.methods,
      }
    case ParameterActionTypes.FIND_METHODS:
      return {
        ...state,
        loading: true,
        methods: [],
      };
    case ParameterActionTypes.FIND_METHODS_SUCCESS:
      return {
        ...state,
        loading: false,
        methods: action.payload.methods,
      };
    case ParameterActionTypes.FIND_METHOD_ID:
      return {
        ...state,
        loading: true,
        methods: [],
      };
    case ParameterActionTypes.FIND_METHOD_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        methods: action.payload.methods,
      };
    case ParameterActionTypes.FIND_METHOD_ID_FAILURE:
      return {
        ...state,
        methods: [],
      };
    case ParameterActionTypes.VIEW_CHECKOUT:
      return {
        ...state,
        viewCheckout: action.payload.viewCheckout,
      };
    case ParameterActionTypes.METHOD_SEL:
      return {
        ...state,
        loading: true,
        methodSplit: [
        ],
        methods: [],
      };
    case ParameterActionTypes.METHOD_SET_SELECTED:
      return {
        ...state,
        method: action.payload.method,
        payOnDelivery: false,
      };
    case ParameterActionTypes.METHOD_CLEAR:
      return {
        ...state,
        method: undefined,
      };
    case ParameterActionTypes.FIND_STORE_ALL:
      return {
        ...state,
        loading: true,
      };
    case ParameterActionTypes.FIND_STORE_ALL_SUCCESS:
      return {
        ...state,
        loading: false,
        stores: action.payload.stores,
      };
    case ParameterActionTypes.FIND_STORE_ALL_FAILURE:
      return {
        ...state,
        loading: false,
        stores: [],
      };
    case ParameterActionTypes.FIND_LOCKER_ALL:
      return {
        ...state,
        loading: true,
        lockers: [],
      };
    case ParameterActionTypes.FIND_LOCKER_ALL_SUCCESS:
      return {
        ...state,
        loading: false,
        lockers: action.payload.lockers,
      };
    case ParameterActionTypes.STORE_SEL:
      return {
        ...state,
        loading: false,
        address: undefined,
        locker: undefined,
        store: action.payload.store,
      };
    case ParameterActionTypes.LOCKER_SEL:
      return {
        ...state,
        address: undefined,
        store: undefined,
        locker: action.payload.locker,
      };
    case ParameterActionTypes.BTN_NEXT_CHECKOUT:
      return {
        ...state,
        btnCheckoutNext: !state.btnCheckoutNext,
      };
    case ParameterActionTypes.FIND_SHIPPING_VALUE:
      return {
        ...state,
        loading: true,
      };
    case ParameterActionTypes.FIND_SHIPPING_VALUE_SUCCESS: {
      let andress: UserAddresses = {} as UserAddresses;
      if (state.address) {
        return {
          ...state,
          loading: false,
          address: {
            ...state.address,
          },
          shippingOptions: action.payload.shippintRates,
        };
        //konsole.log('ParameterActionTypes.FIND_SHIPPING_VALUE_SUCCESS->state.address: ', state.address)
      }
      //konsole.log('ParameterActionTypes.FIND_SHIPPING_VALUE_SUCCESS: ', andress)
      return {
        ...state,
        address: andress,
        store: undefined,
        locker: undefined,
        shippingOptions: action.payload.shippintRates,
      };
    }
    case ParameterActionTypes.SELECT_SHIPPING_OPTION: {
      return {
        ...state,
        selectedShippingOption: action.payload.shippingOption,
        address: {
          ...state.address,
          shipping: action.payload.shippingOption,
        } as UserAddresses,
      };
    }
    case ParameterActionTypes.CLEAR_SHIPPING_OPTION: {
      return {
        ...state,
        selectedShippingOption: undefined
      };
    }
    case ParameterActionTypes.CALCULATE_SHIPPING_RATE_SPECIFC: {
      return {
        ...state,
        loading: true,
      };
    }
    case ParameterActionTypes.CALCULATE_SHIPPING_RATE_SPECIFC_SUCCESS: {
      const shippingOptions = state.shippingOptions?.map(
        option => {
          if (option.id === action.payload.shippingOption.id) {
            return {
              ...option,
              price: action.payload.shippingOption.price
            }
          }
          return option;
        }
      );
      return {
        ...state,
        loading: false,
        selectedShippingOption: action.payload.shippingOption,
        shippingOptions,
        address: {
          ...state.address,
          shipping: action.payload.shippingOption,
        } as UserAddresses,
      };
    }
    case ParameterActionTypes.METHOD_CREATER:
      return {
        ...state,
        loading: true,
        isCreatedMethod: true,
      };
    case ParameterActionTypes.METHOD_CREATER_SUCCESS:
      return {
        ...state,
        loading: false,
        isCreatedMethod: false,
      };
    case ParameterActionTypes.SET_MESSAGE_TOAST:
      return {
        ...state,
        messageToast: action.payload.message,
        typeToast: action.payload.type,
        messageTranslationId: action.payload.messageTranslationId,
      };
    case ParameterActionTypes.SET_MESSAGE_TOAST_CLEAR:
      return {
        ...state,
        messageToast: '',
        typeToast: undefined,
        messageTranslationId: ''
      };
    case ParameterActionTypes.METHOD_FAVORITE:
      return {
        ...state,
        loading: true,
      };
    case ParameterActionTypes.METHOD_FAVORITE_SUCCESS:
      if (state.methods)
        state.methods?.filter(method =>
          method.id === action.payload.method.id
            ? (method.selected = 1)
            : (method.selected = 0),
        );

      return {
        ...state,
        loading: false,
      };
    case ParameterActionTypes.METHOD_REMOVE:
      return {
        ...state,
        loading: true,
      };
    case ParameterActionTypes.METHOD_REMOVE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ParameterActionTypes.ADDRESSES_FIND_POSTCODE_REQUEST:
      return {
        ...state,
        loading: true,
        address: undefined,
      };
    case ParameterActionTypes.ADDRESSES_FIND_POSTCODE_SUCCESS:
      return {
        ...state,
        loading: false,
        address: action.payload.addresse,
      };
    case ParameterActionTypes.ADDRESSES_FIND_POSTCODE_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case ParameterActionTypes.ADDRESSES_FIND_ALL_REQUEST:
      return {
        ...state,
        loading: true,
        addresses: [],
      };
    case ParameterActionTypes.ADDRESSES_FIND_ALL_SUCCESS:
      return {
        ...state,
        loading: false,
        addresses: action.payload.addresses,
      };
    case ParameterActionTypes.ADDRESSES_FIND_ALL_FAILURE:
      return {
        ...state,
        loading: false,
        addresses: [],
      };
    case ParameterActionTypes.ADDRESSES_SEL:
      return {
        ...state,
        messageToast: '',
        loading: true,
        store: undefined,
      };
    case ParameterActionTypes.ADDRESSES_SEL_SUCCESS:
      return {
        ...state,
        loading: false,
        address: action.payload.addresse,
      };
    case ParameterActionTypes.ADDRESSES_EDIT_REQUEST:
      return {
        ...state,
        loading: false,
        addressEdit: action.payload.addresse,
      };
    case ParameterActionTypes.ADDRESSES_CREATED_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
        messageToast: '',
      };
    case ParameterActionTypes.ADDRESSES_CREATED_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ParameterActionTypes.ADDRESSES_CREATED_UPDATE_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case ParameterActionTypes.ADDRESSES_REMOVE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ParameterActionTypes.ADDRESSES_REMOVE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ParameterActionTypes.ADDRESSES_REMOVE_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case ParameterActionTypes.OPEN_MENU_ACCOUNT:
      return {
        ...state,
        openMenuAccuntId: action.payload.menuId,
      };
    case ParameterActionTypes.OPEN_MENU_ACCOUNT_CLEAR:
      return {
        ...state,
        openMenuAccuntId: undefined,
      };
    case ParameterActionTypes.SET_SERVICE_INFO:
      return {
        ...state,
        serviceInfo: action.payload.serviceInfo,
      };
    case ParameterActionTypes.CLEAR_SERVICE_INFO:
      return {
        ...state,
        serviceInfo: undefined,
      };
    case ParameterActionTypes.PAY_ON_DELIVERY:
      return {
        ...state,
        payOnDelivery: true,
        method: undefined
      };
    case ParameterActionTypes.SELECT_LANGUAGE:
      return {
        ...state,
        language: action.payload.language,
      };
    case ParameterActionTypes.CLEAR_LOADING:
      return {
        ...state,
        loading: false,
      };
    case ParameterActionTypes.SET_MULTISTORE_SELECTED:
      Cookies.set(
        '@ConectoVarejo:multistoreSelected', 
        JSON.stringify(action.payload.store),
        { expires: 365 },
      );
      return {
        ...state,
        multistoreSelected: action.payload.store
      }
    case ParameterActionTypes.UPDATE_COORDINATES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ParameterActionTypes.UPDATE_COORDINATES_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
